import React, { useState, useEffect } from "react";
import styling from "./EditMyStock.module.css";
import { MdClose } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import firebase from "../../../../../firebase/firebase";
import { salesItem } from "../../../../../redux/actions/actions";
import { notify, ToastContainer } from "../../../../Notify/Notify";

function EditMyStock({ toggleEditScreen, itemDetails }) {
  const [itemName, setItemName] = useState("");
  const [quantity, setQuantity] = useState("");
  const [measurment, setMeasurment] = useState("pieces");
  const [costPrice, setCostPrice] = useState("");
  const [sellingPrice, setSellingPrice] = useState("");
  const userInfo = useSelector((state) => state.user);
  const dispatch = useDispatch();

  useEffect(() => {
    if (itemDetails) {
      setItemName(itemDetails.itemName);
      setQuantity(itemDetails.quantity);
      setMeasurment(itemDetails.measurment);
      setCostPrice(itemDetails.costPrice);
      setSellingPrice(itemDetails.sellingPrice);
    }
  }, [itemDetails]);

  const updateItemToDB = () => {
    if (
      itemName.length > 2 &&
      parseInt(quantity) &&
      measurment &&
      parseInt(costPrice) &&
      parseInt(sellingPrice)
    ) {
      const updatedItem = {
        itemName,
        quantity: parseInt(quantity),
        measurment,
        costPrice: parseInt(costPrice),
        sellingPrice: parseInt(sellingPrice),
      };

      const db = firebase.firestore();
      db.collection("shops")
        .doc(userInfo.shopName)
        .update({
          [`products.${itemName}`]: updatedItem,
        })
        .then(() => {
          toggleEditScreen("added");
          dispatch(salesItem({ [`${itemName}`]: updatedItem }));
          console.log("Updated item successfully");
        })
        .catch((error) => {
          notify("error", "Something went wrong");
          console.error("Error updating document: ", error);
        });
    } else {
      notify("error", "All fields are required");
      console.log("error", "All fields are required");
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    updateItemToDB();
  };

  return (
    <>
      <div
        className={styling.EditMyStock}
        onClick={(e) => {
          // close when clicking on the dark background
          if (e.target === e.currentTarget) toggleEditScreen();
        }}
      >
        <div className={styling.innerScreen}>
          <button
            type="button"
            className={styling.closeIconButton}
            onClick={() => toggleEditScreen()}
            aria-label="Close edit item dialog"
          >
            <MdClose className={styling.closeIcon} />
          </button>

          <form className={styling.formContent} onSubmit={handleSubmit}>
            <h2 className={styling.formHeading}>Edit Item</h2>

            <div className={styling.formRow}>
              <label className={styling.fieldLabel}>Item Name</label>
              <input
                type="text"
                placeholder="item name"
                value={itemName}
                disabled
                className={styling.readonlyInput}
              />
            </div>

            <div className={styling.formRow}>
              <label className={styling.fieldLabel}>Quantity</label>
              <input
                type="number"
                placeholder="edit quantity"
                value={quantity}
                onChange={(e) => setQuantity(e.target.value)}
              />
            </div>

            <div className={styling.formRow}>
              <label className={styling.fieldLabel}>Measurement</label>
              <select
                value={measurment}
                onChange={(e) => setMeasurment(e.target.value)}
              >
                <option value="pieces">pieces</option>
                <option value="kg">kg</option>
                <option value="liter">liter</option>
              </select>
            </div>

            <div className={styling.formRow}>
              <label className={styling.fieldLabel}>Cost Price</label>
              <input
                type="number"
                placeholder="edit cost price"
                value={costPrice}
                onChange={(e) => setCostPrice(e.target.value)}
              />
            </div>

            <div className={styling.formRow}>
              <label className={styling.fieldLabel}>Selling Price</label>
              <input
                type="number"
                placeholder="edit selling price"
                value={sellingPrice}
                onChange={(e) => setSellingPrice(e.target.value)}
              />
            </div>

            <button type="submit" className={styling.updateButton}>
              Update Item
            </button>
          </form>
        </div>
      </div>
      <ToastContainer />
    </>
  );
}

export default EditMyStock;
